import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import shareVideo from '../assets/share.mp4';
import logo from '../assets/logowhite.png';
import { GoogleOAuthProvider } from '@react-oauth/google';
import jwt_decode from 'jwt-decode'

import { client } from '../client';

const Login = () => {
  //const {user, setUser} = userState({});
  const navigate = useNavigate();
  const responseGoogle = (response) => {
    localStorage.setItem('user', JSON.stringify(jwt_decode(response.credential)));
    var userObj = jwt_decode(response.credential)
    console.log(userObj)
    const name = userObj.name
    const googleId = userObj.sub
    const imageUrl = userObj.picture
    
    const doc = {
      _id: googleId,
      _type: 'user',
      userName: name,
      image: imageUrl,
    };
    //console.log("doc " + doc.userName)
    client.createIfNotExists(doc).then(() => {
      navigate('/', { replace: true });
    });

    }
      

      
  return (
    <div className="flex justify-start items-center flex-col h-screen">
      <div className=" relative w-full h-full">
        <video
          src={shareVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className="w-full h-full object-cover"
        />

        <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0    bg-blackOverlay">
          <div className="p-5">
            <img src={logo} width="130px" />
          </div>

          <div className="shadow-2xl">
          <GoogleOAuthProvider clientId= {process.env.REACT_APP_GOOGLE_API_TOKEN}>
          <GoogleLogin
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy="single_host_origin"
              useOneTap
              />;
            </GoogleOAuthProvider>;

          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;